import axios from 'axios'
export default {
  get: (url, params) => {
    return new Promise((resolve, reject) => {
      axios.get(url, {params: params})
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  post: (url, postData) => {
    return new Promise((resolve, reject) => {
      axios.post(url, postData)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/request.js